import { useFm } from '@web3/base-hooks';

import styles from './index.module.less';

const NoData = () => {
  const fm = useFm();

  return (
    <div className={styles.container}>
      <img
        data-paint
        className={styles.img}
        src="https://s1.bycsi.com/bybit/deadpool/image-5aee707461684b3386f5974665bbc449.svg"
        alt=""
      />
      <span className={styles.text}>{fm('no_data')}</span>
    </div>
  );
};

export default NoData;
